export const GET_ALL_SERVICES_REQUEST = 'GET_ALL_SERVICES_REQUEST';
export const GET_ALL_SERVICES_SUCCESS = 'GET_ALL_SERVICES_SUCCESS';
export const GET_ALL_SERVICES_FAIL = 'GET_ALL_SERVICES_FAIL';

export const CREATE_SERVICE_REQUEST = 'CREATE_SERVICE_REQUEST';
export const CREATE_SERVICE_SUCCESS = 'CREATE_SERVICE_SUCCESS';
export const CREATE_SERVICE_FAIL = 'CREATE_SERVICE_FAIL';

export const UPDATE_SERVICE_REQUEST = 'UPDATE_SERVICE_REQUEST';
export const UPDATE_SERVICE_SUCCESS = 'UPDATE_SERVICE_SUCCESS';
export const UPDATE_SERVICE_FAIL = 'UPDATE_SERVICE_FAIL';

export const DELETE_SERVICE_REQUEST = 'DELETE_SERVICE_REQUEST';
export const DELETE_SERVICE_SUCCESS = 'DELETE_SERVICE_SUCCESS';
export const DELETE_SERVICE_FAIL = 'DELETE_SERVICE_FAIL';

export const GET_SERVICE_DETAILS_REQUEST = 'GET_SERVICE_DETAILS_REQUEST';
export const GET_SERVICE_DETAILS_SUCCESS = 'GET_SERVICE_DETAILS_SUCCESS';
export const GET_SERVICE_DETAILS_FAIL = 'GET_SERVICE_DETAILS_FAIL';
